import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { StatusKronisJkn } from "@/types/skdp";

async function create(data) {
  const response = await http.postData("/skdp", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function update(id: number, data) {
  const response = await http.putData(`/skdp/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/skdp/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function get(
  params: {
    unit_id?: string;
    rm?: string;
    tgl_kontrol?: string;
    tgl_kontrol_gt?: string;
  } = null
) {
  const response = await http
    .getDataParam(`/skdp`, {
      params: params
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function statusKronis(
  register: string | number
): Promise<StatusKronisJkn | null> {
  try {
    const response = await http.getData(`/register/${register}/skdp-kronis`);
    return response.data.data;
  } catch (e) {
    return null;
  }
}

export default {
  create,
  update,
  destroy,
  get,
  statusKronis
};
